import NotificationPopoverFilter from './NotificationPopoverFilter';
import NotificationPopoverActionButton from './NotificationPopoverActionButton';
import { cva } from 'class-variance-authority';

const actionBar = cva(
  ['mb-2 flex justify-between bg-gray-100 rounded-lg px-4 py-2'],
  {
    variants: {
      loading: {
        true: 'animate-pulse',
      },
    },
  },
);

export default function NotificationPopoverActionBar({
  unreadNotificationsCount,
  unreadOnly,
  setUnreadOnly,
  markAllAsRead,
  navigate,
  reload,
  loading,
}) {
  return (
    <div className={actionBar({ loading })}>
      <div className="flex space-x-3 items-center">
        <NotificationPopoverActionButton
          icon="fa-check-double"
          onClick={() => markAllAsRead()}
        />

        <NotificationPopoverActionButton
          icon="fa-refresh"
          onClick={() => reload()}
          loading={loading}
        />
      </div>

      <NotificationPopoverFilter
        unreadCount={unreadNotificationsCount}
        unreadOnly={unreadOnly}
        setUnreadOnly={setUnreadOnly}
      />

      <NotificationPopoverActionButton
        icon="fa-cog"
        onClick={() => navigate('/user/notification-preferences')}
      />
    </div>
  );
}
